exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banners{z-index:100}.banners__list{display:flex;flex-wrap:wrap}.banners__item{position:relative;width:100%}.banners__item:after{position:absolute;content:\"\";width:100%;height:100%;top:0;left:0;z-index:10;background:hsla(0,0%,100%,.25);display:none}.banners__item:hover:after{display:block}.banners__img{width:100%}@media only screen and (min-width:480px){.banners__list{flex-wrap:nowrap}.banners__item{width:auto}}@media only screen and (min-width:992px){.banners{margin:-112px 0 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c9232ebc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bannersBlock.vue
// module id = 213
// module chunks = 0